import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { QueenElizabethTributes } from './components/QueenElizabethTribute'
import { GuestBook, Props } from './GuestBook'

const queryClient = new QueryClient()
export interface GuestBookRegistrationProps extends Props {}

export const GuestBookRegistration = createRegisterableComponent(
    'guestbook',
    (props: GuestBookRegistrationProps, services) => {
        return (
            <QueryClientProvider client={queryClient}>
                <GuestBook
                    onEvent={services.onEvent}
                    logger={services.log}
                    campaign={props.campaign}
                    introContent={
                        props.campaign === `Queen's Tribute` ? (
                            <QueenElizabethTributes />
                        ) : null
                    }
                />
            </QueryClientProvider>
        )
    },
)
